export default __webpack_public_path__ + "static/media/navLogo.27c67e7d.svg";